import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "type", "autocomplete", "disabled", "min", "max", "maxlength", "placeholder", "required", "inputmode"]

import { computed, onMounted, ref } from 'vue';

type InputType = 'text' | 'search' | 'email' | 'tel' | 'number' | 'date' | 'url';
type InputVariant = 'default' | 'form';


export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    modelValue: { default: '' },
    type: { default: 'text' },
    autocomplete: { default: undefined },
    disabled: { type: Boolean, default: false },
    min: { default: undefined },
    max: { default: undefined },
    defaultValue: { default: undefined },
    numericOnly: { type: Boolean, default: false },
    maxlength: { default: undefined },
    placeholder: { default: '' },
    required: { type: Boolean, default: false },
    variant: { default: 'default' }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "keydown"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const inputRef = ref<HTMLInputElement | null>(null);

const inputClasses = computed(() => [
  'ui-input',
  `ui-input--${props.variant}`,
  {
    'ui-input--disabled': props.disabled
  }
]);

function focus(): void {
  inputRef.value?.focus();
}

function handleInput(event: Event): void {
  const target = event.target as HTMLInputElement;
  const value = props.numericOnly ? target.value.replace(/\D/g, '') : target.value;
  if (value !== target.value) {
    target.value = value;
  }
  emit('update:modelValue', value);
  emit('input', event);
}

function handleBlur(event: FocusEvent): void {
  const target = event.target as HTMLInputElement;
  if (props.numericOnly) {
    const fallback = String(props.defaultValue ?? '');
    const numericValue = Number.parseInt(target.value, 10);
    const hasValue = target.value.length > 0 && Number.isFinite(numericValue);
    const boundedValue = hasValue
      ? Math.min(props.max ?? Number.POSITIVE_INFINITY, Math.max(props.min ?? Number.NEGATIVE_INFINITY, numericValue))
      : fallback;

    const nextValue = boundedValue === '' ? '' : String(boundedValue);
    if (nextValue !== target.value) {
      target.value = nextValue;
      emit('update:modelValue', nextValue);
    }
  }
  emit('blur', event);
}

onMounted(() => {
  if (props.modelValue || props.defaultValue === undefined) return;
  emit('update:modelValue', String(props.defaultValue));
});

__expose({
  focus,
  inputRef
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    ref_key: "inputRef",
    ref: inputRef,
    value: __props.modelValue,
    type: __props.type,
    autocomplete: __props.autocomplete,
    disabled: __props.disabled,
    min: __props.min,
    max: __props.max,
    maxlength: __props.maxlength,
    placeholder: __props.placeholder,
    required: __props.required,
    inputmode: __props.numericOnly ? 'numeric' : undefined,
    class: _normalizeClass(inputClasses.value),
    onInput: handleInput,
    onFocus: _cache[0] || (_cache[0] = ($event: any) => (emit('focus', $event))),
    onBlur: handleBlur,
    onKeydown: _cache[1] || (_cache[1] = ($event: any) => (emit('keydown', $event)))
  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})